import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "@/shared/auth/usePermission";
import type { Permission } from "@/shared/auth/permissions";

interface RequirePermissionProps {
  permission: Permission;
  children: ReactNode;
}

/**
 * Route guard on a permission from `/api/auth/me` instead of a role literal.
 * Mount it inside `RequireRole` (the shell), which already settles loading and
 * authentication; a session without the permission is sent to `/403`. This
 * only decides what to render — the API enforces the same permission.
 */
export function RequirePermission({ permission, children }: RequirePermissionProps) {
  const allowed = usePermission(permission);
  if (!allowed) return <Navigate to="/403" replace />;
  return <>{children}</>;
}
